import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { getGtmId } from '../../../utils';
import { GtmPageView } from '../../../utils/gtm/pages/GTMPageView.types';

import { PushEventWithDelay } from '../../../utils/gtm/TagManager';

export function useGTMPageView(getPageView: () => GtmPageView | null): void;
export function useGTMPageView<T extends ReadonlyArray<unknown>>(
  getPageView: (deps: T) => GtmPageView | null,
  deps: T
): void;
export function useGTMPageView<T extends ReadonlyArray<unknown>>(
  getPageView: (deps?: T) => GtmPageView | null,
  deps?: T
): void {
  const [gtmId] = useState(getGtmId());

  useEffect(() => {
    gtmId &&
      TagManager.initialize({
        gtmId,
      });

    const pageViewEvent = getPageView(deps);
    pageViewEvent && PushEventWithDelay(pageViewEvent);
  }, deps || []);
}

export function useGTMCustom(gtmId: string, delay = 5000) {
  useEffect(() => {
    const id = setTimeout(() => {
      gtmId &&
        TagManager.initialize({
          gtmId,
        });
    }, delay);

    return () => {
      clearTimeout(id);
    };
  }, []);
}
